export default class Money {
    static toData(money) {
        if (money === null) {
            return null;
        }
        return {
            amount: money.amount,
            currency: money.currency,
        };
    }

    static fromData(data) {
        const money = new Money();
        money.config = this.config.hasOwnProperty(data.currency) ? this.config[data.currency] : this.config.default;
        money.amount = data.amount;
        money.currency = data.currency;
        Object.seal(money);
        return money;
    }

    static fromNumber(number, currency) {
        if (number === '' || number === null) {
            return null;
        }
        const money = new Money();
        money.config = this.config.hasOwnProperty(currency) ? this.config[currency] : this.config.default;
        money.amount = {
            denominator: 10 ** money.config.decimalPlaces,
        };
        money.amount.numerator = Math.round(number * money.amount.denominator);
        money.currency = currency;

        Object.seal(money);
        return money;
    }

    toNumber() {
        return Number.parseFloat((this.amount.numerator / this.amount.denominator).toFixed(this.config.decimalPlaces));
    }

    toLocalizedString() {
        return this.toNumber().toFixed(this.config.decimalPlaces).toString().replace('.', this.config.decimalSeparator);
    }

    format() {
        return `${this.toLocalizedString()} ${this.currency}`;
    }

    static fromLocalizedString(localizedString, currency) {
        const config = this.config.hasOwnProperty(currency) ? this.config[currency] : this.config.default;
        return this.fromNumber(Number.parseFloat(localizedString.replace(config.decimalSeparator, '.')), currency);
    }

    static isValidLocalizedString(localizedString, currency) {
        const config = this.config.hasOwnProperty(currency) ? this.config[currency] : this.config.default;
        const regexString = `^[0-9]\\d*(?:${config.decimalSeparator}\\d{0,${config.decimalPlaces}})?$`;
        const regex = RegExp(regexString);
        const valid = regex.test(localizedString);

        return valid;
    }
}

Money.config = {
    default: { decimalPlaces: 2, decimalSeparator: ',' },
    EUR: { decimalPlaces: 2, decimalSeparator: ',' },
};
